import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { DemandPartner } from '../shared/domain/demand-partner.model';
import { BridgeAdUnitDemandPartnerResponse } from './domain/bridge-ad-unit-demand-partner-response.model';
import { Publisher } from '../shared/domain/publisher.model';
import { BridgeAdUnitDemandPartnerLine } from './domain/bridge-ad-unit-demand-partner-line.model';
import { DemandPartnerRequest } from './domain/demand-partner-request.model';
import { BridgeAdUnitDpHbIdStatus } from '../shared/domain/bridge-ad-unit-hb-id-status.enum';
import { HttpUtils } from '../shared/utils/http-utils';
import { HbCsvImportResult } from './domain/hb-csv-import-result.model';
import { DomainDpApproval, DomainDpStatus } from '../shared/domain/domain-dp-approval.model';
import { SiteApprovalsDpResponse } from '../shared/domain/site-approval-request.model';
import { SitesCsvImportResult } from './domain/sites-csv-import-result.model';

@Injectable()
export class DpStatsService {

  constructor(private http: HttpClient) {
  }

  getPublishers(statuses: string[]): Observable<Publisher[]> {
    return this.http.get<Publisher[]>(`${environment.serviceUrl}/ad-stats/dp-stats/publishers`, {
      params: HttpUtils.getHttpParams({
        status: statuses
      })
    });
  }

  getDemandPartner(): Observable<DemandPartner> {
    return this.http.get<DemandPartner>(`${environment.serviceUrl}/ad-stats/dp-stats/demand-partner`);
  }

  adUnits(statuses: BridgeAdUnitDpHbIdStatus[] = []): Observable<BridgeAdUnitDemandPartnerResponse> {
    return this.http.get<BridgeAdUnitDemandPartnerResponse>(`${environment.serviceUrl}/ad-stats/dp-stats/ad-units`, {
      params: HttpUtils.getHttpParams({
        status: statuses
      })
    });
  }

  adUnitsUpdate(data: BridgeAdUnitDemandPartnerLine[]) {
    return this.http.put(`${environment.serviceUrl}/ad-stats/dp-stats/ad-units`, data);
  }

  adUnitRequest(data: DemandPartnerRequest) {
    return this.http.post(`${environment.serviceUrl}/ad-stats/dp-stats/ad-unit-request`, data);
  }

  siteApproval(page, pageSize, status: DomainDpStatus[], domainName): Observable<SiteApprovalsDpResponse> {
    return this.http.get<SiteApprovalsDpResponse>(`${environment.serviceUrl}/ad-stats/dp-stats/site-approval`, {
      params: HttpUtils.getHttpParams({
        page: page,
        size: pageSize,
        status: status,
        urlLike: domainName
      })
    });
  }

  siteApprovalUpdate(app: DomainDpApproval[]): Observable<SiteApprovalsDpResponse> {
    return this.http.put<SiteApprovalsDpResponse>(`${environment.serviceUrl}/ad-stats/dp-stats/site-approval`, app);
  }

  importHbId(file: File) {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post<HbCsvImportResult>(`${environment.serviceUrl}/ad-stats/dp-stats/import-hbid`, formData);
  }

    exportSites(status: DomainDpStatus[]) {
    // return this.http.get(`${environment.serviceUrl}/ad-stats/dp-stats/site-approval/export`, {
    //     responseType: 'text',
    //     // params: HttpUtils.getHttpParams({
    //     //     publisher_id: pubId,
    //     //     paid: paid
    //     // })
    // });
    return this.http.get<any>(`${environment.serviceUrl}/ad-stats/dp-stats/site-approval/export`, Object.assign({}, {
      observe: 'response',
      responseType: 'text',
    }, {
      params: HttpUtils.getHttpParams({
        status: status
      })
    }));
  }

  statusExport(pubId: string[], dp: string[]): Observable<any> {
    return this.http.get<any>(`${environment.serviceUrl}/ad-stats/adstxt/status/export`, Object.assign({}, {
      observe: 'response',
      responseType: 'text',
    }, {
      params: HttpUtils.getHttpParams({
        publisherId: pubId,
        dp: dp
      })
    }));
  }

  importSites(file: File) {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post<SitesCsvImportResult>(`${environment.serviceUrl}/ad-stats/dp-stats/site-approval/import`, formData);
  }
}
